import { Injectable } from '@angular/core';

import { Images, Occ, OccConfig, Product, ProductImageNormalizer } from '@spartacus/core';

import '../models/augmented-spartacus-core.model';

import { ImageService } from './image.service';
import { OccBundle } from '../models';

@Injectable({
  providedIn: 'root'
})
export class CustomProductImageNormalizer extends ProductImageNormalizer {
  constructor(protected config: OccConfig, private imageService: ImageService) {
    super(config);
  }

  normalize(source: Occ.Image[]): Images {
    const images = {};
    if (source) {
      for (const image of source) {
        const isList = Object.prototype.hasOwnProperty.call(image, 'galleryIndex');
        if (!Object.prototype.hasOwnProperty.call(images, image.imageType)) {
          images[image.imageType] = isList ? [] : {};
        }

        let imageContainer;
        if (isList && !images[image.imageType][image.galleryIndex]) {
          images[image.imageType][image.galleryIndex] = {};
        }

        if (isList) {
          imageContainer = images[image.imageType][image.galleryIndex];
        } else {
          imageContainer = images[image.imageType];
        }

        imageContainer[image.format] = this.imageService.normalizeMedia(image);
      }
    }
    return images;
  }

  convert(source: Occ.Product, target?: Product): Product {
    if (!source) {
      return null;
    }
    target = super.convert(source, target);
    const occBundles: OccBundle[] = source['bundles'];
    const occIndexedBundles: OccBundle[] = source['indexedBundles'];
    const occAccessories: Occ.Product[] = source['accessories'];
    const occDetachedPieces: Occ.Product[] = source['detachedPieces'];
    if (occBundles) {
      target.bundles = occBundles.map((bundle) => ({
        ...bundle,
        galleryImages: this.normalize(bundle.galleryImages),
        products: bundle.products as any[]
      }));
    }
    if (occIndexedBundles) {
      target.indexedBundles = occIndexedBundles.map((bundle) => ({
        ...bundle,
        galleryImages: this.normalize(bundle.galleryImages),
        products: []
      }));
    }
    if (occAccessories) {
      target.accessories = occAccessories.map((accessory) => this.convert(accessory));
    }
    if (occDetachedPieces) {
      target.detachedPieces = occDetachedPieces.map((detachedPiece) => this.convert(detachedPiece));
    }
    return target;
  }
}
